import palette from '../palette';

export default {
    "@global": {
        "::-webkit-scrollbar-thumb": {
            background: palette.primary.main
        },
    },
};